import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "@/lib/scroll";

export const Timeline = () => (
  <section data-testid="timeline-section" className="py-28 sm:py-40 bg-[#0D0D0D] text-[#FAF8F5]">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10">
      <Reveal><Overline light>La vraie vie</Overline></Reveal>
      <Reveal delay={0.1}>
        <h2 className="font-display uppercase tracking-tight leading-[1.02] text-4xl sm:text-6xl mt-6 max-w-3xl">
          Une journée ordinaire. SOLAMOVE s'y glisse.
        </h2>
      </Reveal>

      <div className="mt-20 border-t border-white/10">
        {IMAGES.timeline.map((slot, i) => (
          <Reveal key={slot.time} delay={0.05}>
            <div
              data-testid={`timeline-card-${slot.time.replace(":", "")}`}
              className={`group grid md:grid-cols-12 gap-6 md:gap-10 items-center py-10 md:py-14 border-b border-white/10 ${i % 2 === 1 ? "md:[direction:rtl]" : ""}`}
            >
              <div className="md:col-span-3 [direction:ltr]">
                <p className="font-mono-alt text-3xl sm:text-5xl text-[#FAF8F5]/90 group-hover:text-[#CBD5C0] transition-colors duration-700">{slot.time}</p>
              </div>
              <div className="md:col-span-4 [direction:ltr]">
                <p className="font-display uppercase tracking-tight text-2xl sm:text-3xl">{slot.label}</p>
              </div>
              <div className="md:col-span-5 [direction:ltr] overflow-hidden">
                <img
                  src={slot.src}
                  alt={`${slot.time} — ${slot.label}`}
                  loading="lazy"
                  className="w-full aspect-[16/10] object-cover grayscale-[0.3] group-hover:grayscale-0 group-hover:scale-105 transition-[transform,filter] duration-[1.6s] ease-out"
                />
              </div>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.1}>
        <p className="font-display uppercase tracking-tight leading-[1.05] text-3xl sm:text-5xl lg:text-6xl mt-24 text-center max-w-4xl mx-auto">
          Votre journée ne change pas.<br />
          <span className="text-[#CBD5C0]">SOLAMOVE s'y intègre, simplement.</span>
        </p>
      </Reveal>
    </div>
  </section>
);
